export const courseType = Object.freeze({
	ONLINE: "Online",
	ONSITE: "Onsite",
});

export type TCourseType = (typeof courseType)[keyof typeof courseType];
